import React, { SVGProps } from 'react';

const PencilIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 13 13"
			fill="none"
			{...props}
		>
			<g clipPath="url(#clip0_24425_184793)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.67526 1.50872C9.9532 1.23077 10.404 1.23077 10.6819 1.50872L11.4915 2.31834C11.7695 2.59629 11.7695 3.04709 11.4915 3.32505L10.2476 4.56895L8.3357 2.84821L9.67526 1.50872ZM7.72201 3.46187L2.11789 9.0657C1.8337 9.3502 1.64934 9.71869 1.59248 10.1164L1.3773 11.6229L2.8837 11.4077C3.2816 11.3509 3.6502 11.1665 3.9343 10.8824L9.63397 5.18263L7.72201 3.46187ZM11.2947 0.895903C10.6783 0.279495 9.67883 0.279491 9.06243 0.895891L1.50481 8.45314C1.08828 8.87001 0.817937 9.41031 0.734523 9.99388L0.355957 12.6443L3.00634 12.2657C3.5898 12.1823 4.13042 11.912 4.54714 11.4953L12.1043 3.93786C12.7207 3.32146 12.7207 2.32193 12.1043 1.70552L11.2947 0.895903Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_24425_184793">
					<rect width="13" height="13" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default PencilIcon;
